export default __webpack_public_path__ + "static/media/5223.e0278a45.png";